import React from 'react';

const HotelResults = () => {
  return (
    <div id="App"></div>
  );
};

export default HotelResults; 